import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  Comparison,
  OfferType,
  Offers,
  ReplacementOffer,
} from 'libs/shared/util/src/lib/models';

@Component({
  selector: 'app-model-comparison',
  templateUrl: './model-comparison.component.html',
  styleUrls: ['./model-comparison.component.scss'],
})
export class ModelComparisonComponent {
  @Input() comparisons: Comparison[];
  @Input() offers: Offers;
  @Input() previousUrl: string;

  @Output() selected: EventEmitter<ReplacementOffer> = new EventEmitter();
  @Output() removed: EventEmitter<ReplacementOffer> = new EventEmitter();

  offerType = OfferType;
  showHighlightsOnly = false;

  constructor(private readonly router: Router) {}

  routeBack() {
    if (this.previousUrl?.includes('product-details')) {
      this.router.navigate(['/product-details'], {
        queryParamsHandling: 'preserve',
      });
    } else {
      const singleOption = this.offers.replacement_offers?.length === 1;
      this.router.navigate([singleOption ? '/product-details' : '/offers'], {
        queryParamsHandling: 'preserve',
      });
    }
  }
}
